import { render } from "./EmptyOwnPhenotypeDialogComponent.vue?vue&type=template&id=4fb238d0&scoped=true"
import script from "./EmptyOwnPhenotypeDialogComponent.vue?vue&type=script&lang=js"
export * from "./EmptyOwnPhenotypeDialogComponent.vue?vue&type=script&lang=js"

import "./EmptyOwnPhenotypeDialogComponent.vue?vue&type=style&index=0&id=4fb238d0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb238d0"]])

export default __exports__